$light: #ffffff;

ul {
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 0.25rem;
  padding: 0;
  margin: 0;

  & > li {
    font-weight: 500;
    list-style-type: none;
    font-size: calc($size-1 * 1.15);
    background: darken($color: $light, $amount: 6);
    border-radius: $base-border-radius;
    padding: calc($base-padding / 8) calc($base-padding / 2) calc($base-padding / 4) calc($base-padding / 4);
    cursor: url('data:image/svg+xml,%3Csvg xmlns="http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" width="16" height="16" viewBox="0 0 16 16"%3E%3Cpath fill="currentColor" d="M4.002 2.998a1 1 0 0 1 1.6-.8L13.6 8.2c.768.576.36 1.8-.6 1.8H9.053a1 1 0 0 0-.793.39l-2.466 3.215c-.581.758-1.793.347-1.793-.609z"%2F%3E%3C%2Fsvg%3E'),
      auto;
    @include center;

    &::after {
      content: '×';
      margin-left: calc($base-margin / 2);
      margin-top: calc($base-margin / 2);
      font-size: $size-2;
      cursor: url('data:image/svg+xml,%3Csvg xmlns="http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" width="16" height="16" viewBox="0 0 16 16"%3E%3Cpath fill="currentColor" d="M4.002 2.998a1 1 0 0 1 1.6-.8L13.6 8.2c.768.576.36 1.8-.6 1.8H9.053a1 1 0 0 0-.793.39l-2.466 3.215c-.581.758-1.793.347-1.793-.609z"%2F%3E%3C%2Fsvg%3E'),
        auto;
    }
  }
}
